import { IconExclamationCircle, IconExclamationCircleFilled, IconProps } from '@tabler/icons-react'

import IconWrapper from './IconWrapper'

interface Props extends IconProps {
	filled?: boolean
}

const ErrorIcon = (props: Props) => {
	const { filled = true, ...rest } = props

	const IconComponent = filled ? IconExclamationCircleFilled : IconExclamationCircle
	return <IconWrapper icon={IconComponent} {...rest} />
}

export default ErrorIcon
